module.exports = __webpack_public_path__ + "static/media/encodetobase64.7e3c7561.svg";